import { defineComponent, PropType } from "vue";

import type { UserProfileMenu } from "./profileHelpers.js";

export const UserVoiceSubnav = defineComponent({
    name: "UserVoiceSubnav",

    props: {
        userId: {
            type: String,
            required: true,
        },
        activeMenu: {
            type: String as PropType<UserProfileMenu>,
            required: true,
        },
    },

    setup(props) {
        const items = [
            {
                key     : "voice",
                label   : "Avec les autres",
                icon    : "groups",
                to      : () => `/users/${props.userId}/voice`,
            },
            {
                key     : "voice_self",
                label   : "Ses sessions",
                icon    : "person",
                to      : () => `/users/${props.userId}/voice_self`,
            },
        ] as const;

        return () => (
            <nav class="user-profile-subnav">
                {items.map((item) => (
                    <router-link to={item.to()} class={{ "user-profile-subnav-item": true, active: props.activeMenu === item.key }} key={item.key}>
                        <span class="material-symbols-outlined">{item.icon}</span>
                        {item.label}
                    </router-link>
                ))}
            </nav>
        );
    },
});
